import { Plan } from '@/data/prepaidSim/plan';
import { PrepaidSimData } from '@/@types/json/prepaidSim';

export class PrepaidSimConfig {
  public plans: Plan[];
  public code: number;
  constructor(config: PrepaidSimData) {
    this.code = config.code;
    this.plans = Object.entries(config.plans).map(([id, value]) => {
      return new Plan(id, value.name, value.price);
    });
  }
}
